var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuckyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 127,
    viewBox: "0 0 131 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13_14974)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 45.5,
    rx: 36,
    ry: 37.5,
    fill: "url(#paint0_linear_13_14974)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_13_14974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 -26L53.8776 33.8947L86.75 -16.2868L59.7277 37.2723L113.287 10.25L63.1053 43.1224L123 46.5L63.1053 49.8776L113.287 82.75L59.7277 55.7277L86.75 109.287L53.8776 59.1053L50.5 119L47.1224 59.1053L14.25 109.287L41.2723 55.7277L-12.2868 82.75L37.8947 49.8776L-22 46.5L37.8947 43.1224L-12.2868 10.25L41.2723 37.2723L14.25 -16.2868L47.1224 33.8947L50.5 -26Z",
    fill: "url(#paint1_radial_13_14974)",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_14974",
    x: -27.1,
    y: -16.1,
    width: 120.2,
    height: 123.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.05,
    result: "effect1_foregroundBlur_13_14974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_13_14974",
    x: -29.9,
    y: -33.9,
    width: 160.8,
    height: 160.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.95,
    result: "effect1_foregroundBlur_13_14974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_14974",
    x1: 69,
    y1: 45.5,
    x2: -3,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#1F7504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41E4F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13_14974",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5 50.125) rotate(90) scale(68.875 65.597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DFF8E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyStar);
export default __webpack_public_path__ + "static/media/lucky-star.895abb70e68665163c711a8fca4643a7.svg";
export { ForwardRef as ReactComponent };